import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { usePageUrl } from '../../../../lib/pages'
import { getOrderDetailsPropType } from '../../../../utils/orderTools'
import Spinner from '../../../Spinner'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import Shipment from './Shipment'
import ShippingAddress from './ShippingAddress'

// TODO: Double check copy when there are no fulfillments for an order
const ShipmentsContainer = ({ className, order, urlFragment }) => {
  const { navigate } = usePageUrl()
  if (order) {
    return (
      <div className={className}>
        <HeaderWithSecondaryButton
          buttonText="Back to Order Details"
          headerText={`Order #${order.orderNumber}`}
          onClick={() => navigate(`/account/${urlFragment}/${order.orderId}`)}
        />
        {order.fulfillments.length ? (
          <>
            {order.shippingAddress && (
              <>
                <ShippingAddress order={order} />
                <hr />
              </>
            )}
            {order.fulfillments.map((fulfillment, index) => (
              <Shipment
                hasMultipleShipments={order.fulfillments.length > 1}
                // eslint-disable-next-line react/no-array-index-key
                key={fulfillment.items[0].sku + index}
                fulfillment={fulfillment}
                fulfillmentNumber={index + 1}
              />
            ))}
          </>
        ) : (
          <div>Your order shipment is pending fulfillment.</div>
        )}
      </div>
    )
  }

  return <Spinner loading />
}

ShipmentsContainer.defaultProps = {
  className: '',
}

ShipmentsContainer.propTypes = {
  className: PropTypes.string,
  order: getOrderDetailsPropType(),
  urlFragment: PropTypes.string.isRequired,
}

const StyledShipmentsContainer = styled(ShipmentsContainer)({})

export default StyledShipmentsContainer
